/** 散布図・検量線: x≈0 の点から standard / origin 回帰を推奨（レガシー ScatterPlotView 相当） */
export function recommendRegressionType(
  points: Array<{ x: number; y: number }>
): 'standard' | 'origin' | null {
  if (points.length < 2) return null;
  const zeroPoints = points.filter((point) => Math.abs(point.x) <= 1e-9);
  if (zeroPoints.length === 0) return 'standard';
  const maxAbsY = Math.max(...points.map((point) => Math.abs(point.y)));
  const avgZeroY = zeroPoints.reduce((sum, point) => sum + point.y, 0) / zeroPoints.length;
  const threshold = Math.max(1e-6, maxAbsY * 0.05);
  return Math.abs(avgZeroY) <= threshold ? 'origin' : 'standard';
}
